import React from 'react';
import {CircularProgress} from "@mui/joy";
import Typography from "@mui/joy/Typography";

// components
import BaseApi from "../../utils/BaseApi";
import KpiSubscriberList from "./KpiSubscriberList";
import withNavigate from "../../utils/withNavigate";

// icons
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';


class KpiAllList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscribers: null,
        };
    }

    async componentDidMount() {
        await this.retrieveSubscribers();
    }

    async retrieveSubscribers() {
        const url = 'subscriber/';
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                active: true,
                page_size: 10000,
            }
        );
        this.setState({
            subscribers: response.data.results
        })
    }

    render() {
        if (!this.state.subscribers) {
            return (<CircularProgress/>)
        }
        return (
            <>
                <Typography
                    level={'h1'}
                >
                    КПЭ
                </Typography>
                {this.state.subscribers.map((subscriber) => {
                    return(
                        <>
                            <Typography
                                level={'h2'}
                            >
                                {subscriber.user.last_name} {subscriber.user.first_name}
                                <CalendarMonthIcon onClick={() => {this.props.navigate(`/task/calendar/${subscriber.id}`)}}/>
                            </Typography>
                            <KpiSubscriberList
                                subscriber={subscriber}
                            />
                        </>
                    )
                })}

            </>
        )
    }
}

export default withNavigate(KpiAllList)